import apiWithAuth from './apiWithAuth';

const orderAdminApi = {
    assignShopMember: (orderId, body) =>
        apiWithAuth.post(`/admin-panel/orders-and-invoices/orders/${orderId}/assign-shop-member`, body),

    reassignShopMember: (orderId, body) =>
        apiWithAuth.post(`/admin-panel/orders-and-invoices/orders/${orderId}/reassign-shop-member`, body),

    assignDeliveryBoy: (orderId, deliveryBoyId) =>
        apiWithAuth.post(`/admin-panel/orders-and-invoices/orders/${orderId}/assign-delivery-boy`, {
            deliveryBoyId
        }),

    getTeamMembers: (shopId) =>
        apiWithAuth.get('/shop-team/all', {
            params: { shopId, status: 'ACTIVE', limit: 100 }
        }),

    getShopDeliveryBoys: (shopId) =>
        apiWithAuth.get(`/delivery-boy/user/shop/${shopId}/delivery-boys`),

    getKdDeliveryBoys: (orderId) =>
        apiWithAuth.get('/user-app/order/kd-delivery-boys', { params: { orderId } }),

    searchOrder: (orderId) =>
        apiWithAuth.get('/admin-panel/orders-and-invoices/orders/search', {
            params: { orderId, limit: 1 }
        })
};

export default orderAdminApi;
